<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page page template-padding notifications-page " v-else-if="loaded" >
        
        <b-input-group class="mb-3" >
            <b-form-input v-model="filter" placeholder="Type to search..." class="search-input atlass-input-borderless" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>
        
        <div class="w-100 notifications-container overflow-auto" >
            
            <div class="container font-size-14 mt-4"  >
                <div class="row" >
                    
                    <!-- NO NOTIFICATIONS -->
                    <div class="col-12 text-center alert alert-light" v-if="matches.length == 0"  > You are up to date </div>
                    <!-- NO NOTIFICATIONS -->
                    
                    <!-- NOTIFICATION LIST -->
                    <div class="col-12 notifications font-size-14 mt-2 mb-2" v-for="(notification, index) in matches" v-if="matches.length > 0"  >
                        <div class="row" >
                            
                            <div :class="alertClass(notification)" role="alert">
                                <h4 class="alert-heading font-weight-bold mt-4 mt-md-0"> {{ notification.Name }} </h4>
                                <p class="mt-2" > {{ notification.Description }} </p>
                                
                                <hr v-if="notification.action_btn_text && notification.Status != 'read'" >
                                <p class="mb-0" v-if="notification.action_btn_text && notification.Status != 'read'" >
                                    <a :href="notification.action_btn_url" v-if="notification.action_btn_type == 'link'" class="btn btn-primary" > {{ notification.action_btn_text }} </a>
                                    <a @click="actionClicked( notification )" v-else-if="notification.action_btn_type == 'route'" class="btn btn-primary" > {{ notification.action_btn_text }} </a>
                                </p>
                                
                                <span class="close" v-if="notification.Status == 'read'" >
                                    <span aria-hidden="true" style="font-size:1rem;" > 
                                        <font-awesome-icon :icon="['fas', 'check-double']" /> 
                                        <span style="font-size:0.85rem" > Read </span>
                                    </span>
                                </span>
                                
                                <a @click="markAsRead( notification )" class="close" :id="`tooltip--${notification.id}--notifications-button`" v-else-if="notification.Status == 'unread'" >
                                    <span aria-hidden="true" style="font-size:1rem;" > 
                                        <font-awesome-icon :icon="['fas', 'check-double']" /> 
                                        <span style="font-size:0.85rem" > Mark as read </span>
                                    </span>
                                </a>
                                <b-tooltip :target="`tooltip--${notification.id}--notifications-button`" placement="top" triggers="hover" custom-class="tooltip-narrow" >
                                    Mark notification as read
                                </b-tooltip>
                                
                            </div>
                            
                        </div>
                    </div>
                    <!-- NOTIFICATION LIST -->
                    
                </div>
            </div>
            
            <div class="col-12 text-center mt-4 d-none" v-if="!allDataLoaded && matches.length > 0" > 
                <a @click="loadMore" class="btn" :class="[{'btn-secondary': allDataLoaded},{'btn-primary': !allDataLoaded}]"  > Load more </a>
            </div>
            
        </div>
        
    </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import helper from '@/helpers/helpers.js';    
    
export default {
    name: 'notificationsComponent',
    props: {
        data: { type: [String, Object, Array], default: null },
    },
    data: function(){
        return {
            filter: '',
            notifications: [],
            loaded: false,
            allDataLoaded: false
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        this.notifications = this.data
        this.loaded = true;
    },
    beforeDestroy() {
        
    },
    methods: {
        formatDate(a){
            //return this.$moment.unix(a.datetime).format( 'HH:mm:ss MMM D, YYYY' )
            return helper.formatDate( a.datetime, 'HH:mm:ss MMM D, YYYY' )
        },
        loadMore(){
            
            //console.log(this.allDataLoaded)
            
            if( this.allDataLoaded ){
                this.$toast.warn({
                    title: 'Nothing more to load',
                    message:  'All notifications have been loaded'
                })
            }else{
                
                //this.getData();
                    
            }
                
        },
        
        markAsRead( notification ){
            //console.log(notification)
            
            let ref = this.$firebase.firestore().collection('organizations/'+notification.APPKEY+'/notifications').doc( notification.id )

            let document = JSON.parse(JSON.stringify(notification));
            document.Status = 'read'
            return ref.update( document )
            .then((result)=>{
                notification.Status = 'read'
                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })                
            })
            
        },
        
        actionClicked(notification){
            this.$router.push({ name: notification.action_btn_url });
            this.$parent.fModalClose()
        },
        
        alertClass(notification){
            let classNames = "alert w-100 p-4 "
            if( notification.Status == 'read' ){
                classNames += "alert-light"
            }else{
                if( notification.Type == 'warning' ){
                    classNames += "alert-warning"
                }else if( notification.Type == 'danger' ){
                    classNames += "alert-danger"
                }else if( notification.Type == 'info' ){
                    classNames += "alert-primary"
                }
            }
            
            return classNames
        }
    },
    computed: {
        isAdmin(){
            return this.$store.getters.isAdmin
        },
        
        matches() {
            return this.filter
                ? this.notifications.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if ( row['referralURL'].toLowerCase().includes(this.filter.toLowerCase()) || row['previousURL'].toLowerCase().includes(this.filter.toLowerCase()) ) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
    
    @import '@/assets/css/variables.scss';
    
    .reset-filter{
        position: absolute;
        right:0;
        line-height: 50px;
        font-size: 18px;
        margin-right: 9px;
        margin-top: 9px;
        color: #777;
        z-index: 999;
        cursor: pointer
    }

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .notifications .alert-light{
        background-color: #f1f1f1;
        border-color: #cbcbcb;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/notifications.vue